import Table from './Table';
import Header from './Header';
import Body from './Body';
import Row from './Row';
import SubHeading from './SubHeading';
import Cell from './Cell';
Table.Header = Header;
Table.Body = Body;
Table.Row = Row;
Table.SubHeading = SubHeading;
Table.Cell = Cell;
export const TableBody = Body;
export const TableHeader = Header;
export const TableRow = Row;
export const TableSubHeading = SubHeading;
export const TableCell = Cell;
export default Table;